<template>
  <div class="home">
    <div class="container">
      <h1>《报告解读说明》</h1>
      <h3>请详细阅读，并对以下信息进行提前准备：</h3>
      <h2>专家方要求：</h2>
      <h3>客户需要提交动物疫病和提供相关诊断资料（下方附表）。</h3>
      <h2></h2>
      <h2>服务说明：</h2>
      <h3>检测4项以内的报告分析解读24小时内分析解读报告完毕；</h3>
      <h3>检测4项以上的报告分析48小时内给予答复；</h3>
      <h2></h2>
      <h2>报告查看：</h2>
      <h3>分析解读完毕后，请您在咨询记录中进行查看。</h3>
      <h2></h2>
      <h2></h2>
      <h1 class="left">客户信息填写模板</h1>
      <h3>*前3条红色为必要信息，后7条为非必要信息</h3>
      <h3 class="read">1.养殖数量、养殖模式；</h3>
      <h3 class="read">2.疫苗接种情况： （疫苗品种、接种日龄/日期、疫苗厂家、接种剂量）</h3>
      <h3 class="read">3.发病日龄、发病数量、 死亡率；</h3>
      <h3>4.临床症状：（体温、呼吸、皮肤颜色、眼睛、鼻腔、粪便、尿液、运动、食欲、精神状态、其它） </h3>
      <h3>5.以上临床症状图片； </h3>
      <h3>6.剖检症状：（心脏、肝脏、脾脏、肾脏、淋巴结、胃、肠、扁桃体、肺、气管、鼻窦、脑膜、腹腔、 胸腔、其它） </h3>
      <h3>7.以上剖检症状图片；</h3>
      <h3>8.近期检测报告；</h3>
      <h3>9.用药情况介绍：（药物通用名称、使用剂量、投药方式、生产厂家、 使用天数、治疗效果）；</h3>
      <h3>10.其他补充说明。</h3>
    </div>
  </div>
</template>

<script>
// import { shopCombination } from '@/api/resetApi.js'

export default {
  name: 'announcement',
  data(){
    return{
      tiem: '',
      timer: '',
      goodsList: [],
    }
  },
  created(){
  },
  methods: {
  }
}
</script>

<style lang="scss">
.home {
  max-width: 780px;
  margin: 0 auto;
}
.container {
  padding: 20px 10px;
  h1 {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    font-family: PingFangSC, PingFangSC-Semibold;
    color: #181818;
    padding-bottom: 10px;
  }
  h2 {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    font-family: PingFangSC, PingFangSC-Semibold;
    color: #181818;
    padding-bottom: 10px;
  }
  h3 {
    text-align: left;
    font-size: 16px;
    font-weight: 400;
    font-family: PingFangSC, PingFangSC-Semibold;
    line-height: 25px;
    color: #666;
    padding-bottom: 10px;
  }
  p {
    padding-bottom: 10px;
    text-align: left;
    line-height: 20px;
    font-size: 12px;
    color: #000;
  }
  strong {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    color: #000;
  }
  .left {
    text-align: left;
  }
  span {
    color: #FC3511;
  }
  .read {
    color: #FC3511;
  }
  .address-p {
    padding-bottom: 0;
  }
  .address {
    padding: 10px;
    text-align: right;
  }
}
</style>
